import React from 'react';
import { UserProfileState } from './userProfileState/UserProfileState';
import UserInfo from './components/UserInfo/UserInfo';

const UserInfoPage: React.FC = () => {
	return (
		<UserProfileState>
			<UserInfo />
		</UserProfileState>
	);
};

export default UserInfoPage;
